
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("hq6vS", function(module, exports) {

$parcel$export(module.exports, "default", () => $17126cbb715e98aa$export$2e2bcd8739ae039);

var $eJOHy = parcelRequire("eJOHy");

var $ciFJV = parcelRequire("ciFJV");

var $cBavF = parcelRequire("cBavF");

var $bbdV2 = parcelRequire("bbdV2");

var $9WV7r = parcelRequire("9WV7r");

var $fJ7W6 = parcelRequire("fJ7W6");

var $jd93d = parcelRequire("jd93d");
const $17126cbb715e98aa$var$EMPTY_ENTRY_POINT_PARAMS = {};
const $17126cbb715e98aa$var$IssueSmartRequestSummaryTriggerOld = /*#__PURE__*/ (0, $eJOHy.forwardRef)(({ isCompact: isCompact, totalComments: totalComments, hasComments: hasComments }, ref)=>{
    // The button is the trigger for loading the JsmSmartRequestSummary panel through this entrypoint context
    const issueSmartRequestSummaryEntryPoint = (0, $eJOHy.useContext)((0, $fJ7W6.IssueSmartRequestSummaryEntryPointContext));
    const entryPointTriggerRef = (0, $ciFJV.useEntryPointButtonTrigger)(issueSmartRequestSummaryEntryPoint.entryPointActions);
    const triggerRef = (0, $jd93d.default)(ref, entryPointTriggerRef);
    // Button entrypoint - we load this in asynchronously
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions } = (0, $bbdV2.useEntryPoint)((0, $9WV7r.issueSmartRequestSummaryTriggerEntryPoint), $17126cbb715e98aa$var$EMPTY_ENTRY_POINT_PARAMS);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $eJOHy.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const runtimeProps = (0, $eJOHy.useMemo)(()=>({
            totalComments: totalComments,
            hasComments: hasComments,
            triggerRef: triggerRef,
            isCompact: isCompact
        }), [
        totalComments,
        hasComments,
        isCompact,
        triggerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eJOHy))).createElement((0, $cBavF.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "issueSmartRequestSummaryTrigger",
        packageName: "issueActivityFeed",
        teamName: "Bento",
        fallback: null,
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});
var $17126cbb715e98aa$export$2e2bcd8739ae039 = $17126cbb715e98aa$var$IssueSmartRequestSummaryTriggerOld;

});
parcelRegister("9WV7r", function(module, exports) {

$parcel$export(module.exports, "issueSmartRequestSummaryTriggerEntryPoint", () => $0f90ac942a939143$export$2e121e5cb0435aae);

var $gbpNq = parcelRequire("gbpNq");

var $3Bzqe = parcelRequire("3Bzqe");

const $0f90ac942a939143$export$2e121e5cb0435aae = (0, $3Bzqe.createEntryPoint)({
    root: (0, $gbpNq.JSResourceForInteraction)(()=>(parcelRequire("jQRN3")).then((module)=>module.SmartRequestSummaryTrigger), {
        moduleId: "cf473c59",
        priority: "interaction"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("jQRN3", function(module, exports) {

let $e73c9944ce6d2eed$var$load = (parcelRequire("gLHA4"))(4);
module.exports = $e73c9944ce6d2eed$var$load("kT4ry").then(()=>parcelRequire('ghpMb'));

});




$parcel$global.rlb("eOwa8")
//# sourceMappingURL=index-old.5f09c8e5.js.map
